<div *ngIf="partnerHasOnlyOneMarket$ | async; else showSelectDropdown">
  <p>{{ (theOnlyMarketPartnerHas$ | async)?.name }}</p>
</div>

<ng-template #showSelectDropdown>
  <glxy-select-input
    label="Select Market"
    [formControl]="dropDownFormControl"
    [options]="marketOptionsForSelectInput$ | async"
  ></glxy-select-input>
</ng-template>
